import { Box } from '@mui/material';
import React from 'react';
import { Control } from 'react-hook-form';

import { EditTable } from './TableComponents/EditTable';
import { ReadCellData, ReadTable } from './TableComponents/ReadTable';
import { TableHeader } from './TableComponents/TableHeader';
import { DynamicTableCellConfig, Header } from './types';

type Props = {
  formTableHeader?: React.ReactNode;
  headers: Header[];
  readData: ReadCellData[][];
  editData: DynamicTableCellConfig[][];
  editMode: boolean;
  control: Control;
};

export const LegacyDynamicFormTable = ({
  formTableHeader,
  headers,
  readData,
  editData,
  editMode,
  control,
}: Props) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      {formTableHeader}
      <table>
        <TableHeader headers={headers} edit={editMode} />
        {editMode ? (
          <EditTable editData={editData} control={control} />
        ) : (
          <ReadTable readData={readData} />
        )}
      </table>
    </Box>
  );
};
